import { Link } from 'react-router-dom';
import Layout from '@/components/feature/Layout';
import FaqAccordion from '@/components/feature/FaqAccordion';
import JsonLd from '@/components/base/JsonLd';
import { faqs } from '@/mocks/community';

export default function Faq() {
  return (
    <Layout>
      <JsonLd
        data={{
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          mainEntity: faqs.map((f) => ({
            '@type': 'Question',
            name: f.q,
            acceptedAnswer: { '@type': 'Answer', text: f.a },
          })),
        }}
      />

      <section className="relative overflow-hidden bg-foreground-900 pt-24 md:pt-28 pb-12 md:pb-16 text-center">
        <div className="relative z-10 mx-auto w-full max-w-7xl px-4 md:px-6">
          <h1 className="font-heading text-3xl md:text-5xl text-background-50">常见问题</h1>
          <p className="mx-auto mt-3 max-w-xl text-sm md:text-base text-background-100/90">
            关于羞羞动漫社的常见疑问，这里都为你解答。
          </p>
        </div>
      </section>

      <section className="mx-auto w-full max-w-3xl px-4 md:px-6 py-10 md:py-14">
        <FaqAccordion items={faqs} />
        <div className="mt-8 rounded-2xl bg-background-100 p-5 text-center text-sm text-foreground-600">
          还有其他问题？欢迎前往 <Link to="/contact" className="font-semibold text-primary-700 hover:text-primary-800">联系我们</Link> 页面，我们会尽快回复你。
        </div>
      </section>
    </Layout>
  );
}